import { render } from "./CurrentRestaurantBankDetails.vue?vue&type=template&id=da2c49b6&scoped=true"
import script from "./CurrentRestaurantBankDetails.vue?vue&type=script&lang=js"
export * from "./CurrentRestaurantBankDetails.vue?vue&type=script&lang=js"

import "./CurrentRestaurantBankDetails.vue?vue&type=style&index=0&id=da2c49b6&lang=scss&scoped=true"

import exportComponent from "C:\\xampp\\htdocs\\php\\POS-SYSTEM-BACKUP-STRIPE\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-da2c49b6"]])

export default __exports__